import React from 'react';
import Button from './Button';

// Self-contained error block for the courseShare feature.
export default function ErrorBlock({ message, onRetry }) {
  return (
    <div
      role="alert"
      style={{
        background: 'var(--bg-secondary)',
        border: '1px solid var(--border-subtle)',
        borderRadius: 16,
        padding: '32px 24px',
        textAlign: 'center',
      }}
    >
      <p style={{ color: 'var(--text-secondary)', fontSize: 14, margin: '0 0 16px' }}>
        {message || 'Something went wrong.'}
      </p>
      {onRetry && (
        <Button variant="secondary" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  );
}
